import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./styles.css";

const ROTATING_MESSAGES = [
  "Última Semana",
  "Alta Inmediata",
  "Tenela Ahora",
  "Cotizá Gratis",
];

const STORAGE_KEY = "alarmita-countdown-deadline";
const MIN_DURATION_SECONDS = 6 * 60 * 60;
const MAX_DURATION_SECONDS = 48 * 60 * 60;

const getRandomDurationSeconds = () =>
  Math.floor(
    Math.random() * (MAX_DURATION_SECONDS - MIN_DURATION_SECONDS + 1)
  ) + MIN_DURATION_SECONDS;

const createDeadline = () => Date.now() + getRandomDurationSeconds() * 1000;

const persistDeadline = (deadline) => {
  window.localStorage.setItem(STORAGE_KEY, String(deadline));
};

const getDeadline = () => {
  const storedDeadline = Number(window.localStorage.getItem(STORAGE_KEY));

  if (storedDeadline && storedDeadline > Date.now()) {
    return storedDeadline;
  }

  const nextDeadline = createDeadline();
  persistDeadline(nextDeadline);

  return nextDeadline;
};

const getRemainingSeconds = (deadline) =>
  Math.max(0, Math.floor((deadline - Date.now()) / 1000));

const formatTimeUnit = (value) => String(value).padStart(2, "0");

const getTimeParts = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [
    formatTimeUnit(hours),
    formatTimeUnit(minutes),
    formatTimeUnit(seconds),
  ];
};

const CountdownBar = () => {
  const deadlineRef = useRef(getDeadline());
  const [remainingSeconds, setRemainingSeconds] = useState(() =>
    getRemainingSeconds(deadlineRef.current)
  );
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const updateCountdown = () => {
      const nextRemainingSeconds = getRemainingSeconds(deadlineRef.current);

      if (nextRemainingSeconds > 0) {
        setRemainingSeconds(nextRemainingSeconds);
        return;
      }

      const nextDeadline = createDeadline();
      deadlineRef.current = nextDeadline;
      persistDeadline(nextDeadline);
      setRemainingSeconds(getRemainingSeconds(nextDeadline));
    };

    updateCountdown();

    const countdownInterval = window.setInterval(updateCountdown, 1000);

    return () => window.clearInterval(countdownInterval);
  }, []);

  useEffect(() => {
    const messageInterval = window.setInterval(() => {
      setMessageIndex((currentIndex) =>
        (currentIndex + 1) % ROTATING_MESSAGES.length
      );
    }, 3000);

    return () => window.clearInterval(messageInterval);
  }, []);

  const [hours, minutes, seconds] = getTimeParts(remainingSeconds);
  const currentMessage = ROTATING_MESSAGES[messageIndex];

  return (
    <Link
      to="/cotizador"
      className="countdown-bar"
      aria-label={`${currentMessage} ${hours}:${minutes}:${seconds}. Tiempo restante ${hours} horas, ${minutes} minutos y ${seconds} segundos.`}
    >
      <span className="countdown-bar__messageWrap" aria-hidden="true">
        <span key={currentMessage} className="countdown-bar__message">
          {currentMessage}
        </span>
      </span>
      <span className="countdown-bar__timer" aria-hidden="true">
        <span className="countdown-bar__timeBox">{hours}</span>
        <span className="countdown-bar__separator">:</span>
        <span className="countdown-bar__timeBox">{minutes}</span>
        <span className="countdown-bar__separator">:</span>
        <span className="countdown-bar__timeBox">{seconds}</span>
      </span>
    </Link>
  );
};

export default CountdownBar;
